/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 12/9/14
 * Time: 7:37 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var DomUtilities = require("infra-util/DomUtilities"),
        template = require("connection-templates/chatTab/chatTabLayout.tmpl"),
        ChatTabLayout = {},

        TRANS_CLS_SHOWING = "chat-tab-region-showing",
        TRANS_CLS_REMOVING = "chat-tab-region-removing",
        TRANS_CLS_HIDDEN = "chat-tab-region-hidden";

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        ChatTabLayout = Marionette.Layout.extend({

            template: template,
            className: "chat-tab",
            regions: {
                "chatWindowRegion": ".chat-window-region",
                "chatContactsRegion": ".chat-contacts-region",
                "chatSurveyRegion": ".chat-survey-region"
            },
            events: {
                "transitionend .chat-tab-region": "_onRegionTransitionEnd",
                "webkit-transitionend .chat-tab-region": "_onRegionTransitionEnd"
            },

            initialize: function (options) {

                this._chatVent = options.chatVent;
                this._displayingRegion = this.chatContactsRegion;
                this._transitionSupport = DomUtilities.isTransitionSupported();
            },

            onRender: function () {
                this._bindEvents();
            },

            _bindEvents: function () {

                this.listenTo(this._chatVent, "cpChatUI::layout:chat:show", this._onShowChat);
                this.listenTo(this._chatVent, "cpChatUI::layout:contacts:show", this._onShowContacts);
                this.listenTo(this._chatVent, "cpChatUI::layout:survey:show", this._onShowSurvey);
                this.listenTo(this._chatVent, "cpChatUI::layout:survey:close", this._onCloseSurvey);
            },

            _onShowChat: function () {
                this._showRegion(this.chatWindowRegion);
            },

            _onShowContacts: function () {
                this._showRegion(this.chatContactsRegion);
            },

            _onShowSurvey: function () {
                this._showRegion(this.chatSurveyRegion);
            },

            _onCloseSurvey: function (options) {
                this.chatSurveyRegion.close();
                this._showRegion(options.showRegion);
            },

            _onRegionTransitionEnd: function (e) {

                var target = $(e.target || e.srcElement);

                if (target.hasClass(TRANS_CLS_REMOVING)) {
                    target
                        .removeClass(TRANS_CLS_REMOVING)
                        .addClass(TRANS_CLS_HIDDEN); //cleanup, make sure the faded-out region gets display=none
                }
            },

            _showRegion: function (region) {

                if (this._displayingRegion !== region) {

                    var found = false;

                    _.each(this.regions, function (selector, name) {
                        var currRegion = this[name];
                        var neededClass = "";

                        if (currRegion === region) {   //the region requested to show
                            found = true;
                        }
                        else {
                            if (currRegion.$el) {
                                var cls = currRegion.$el.attr("class");   //get the classes of this region element
                                neededClass = TRANS_CLS_HIDDEN;

                                if (this.$el.is(":visible") && this._transitionSupport && cls.indexOf(TRANS_CLS_HIDDEN) === -1 && cls.indexOf(TRANS_CLS_REMOVING) === -1) { //currently showing
                                    neededClass = TRANS_CLS_REMOVING; //only used if transition supported, otherwise will just hide
                                }
                            }
                        }

                        this._updateRegionClass(currRegion, neededClass); //remove any unneeded classes from the region element and add the necessary class for hiding
                    }, this);

                    if (found) {
                        this._displayActiveRegion(region);
                    }
                }
            },

            _displayActiveRegion: function (region) {
                this._displayingRegion = region;

                if (this._transitionSupport) {
                    setTimeout(_.bind(this._updateRegionClass, this, region, TRANS_CLS_SHOWING), 1); //delay the transition to get a better and consistent fade-in effect
                }
                else {
                    this._updateRegionClass(region, TRANS_CLS_SHOWING);  //just show, no transition
                }
            },

            _updateRegionClass: function (region, neededClass) {
                if (region.$el) {
                    neededClass = neededClass || "";
                    region.$el.attr("class", "chat-tab-region " + region.el.substr(1) + " " + neededClass);
                }
            }
        });

    });
    return ChatTabLayout;
});

